import { Injectable, NgZone } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedService } from '@shared/shared.service';

@Injectable()
export class PermissionGuard  {
  constructor(
    private sharedService: SharedService,
    private router: Router,
    private ngzone: NgZone
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let permissionModules = [];
    permissionModules = JSON.parse(localStorage.getItem('permissionModules'));
    const modulename = route.data.moduleName;
    const alternateModuleNames = route.data.alternateModuleNames;
    localStorage.setItem(
      'currentModule',
      Array.isArray(modulename) ? modulename[0] : modulename,
    );
    return this.checkPermission(
      modulename,
      permissionModules,
      alternateModuleNames,
    ).then(res => {
      if (res) {
        return true;
      } else {
        this.sharedService.setDefaultUrl(permissionModules);
        return false;
      }
    });
  }
  checkPermission(
    modulename,
    permissionModules,
    alternateModuleNames?: string | string[],
  ): Promise<boolean> {
    if (permissionModules) {
      const primary = Array.isArray(modulename) ? modulename : [modulename];
      const alternates = Array.isArray(alternateModuleNames)
        ? alternateModuleNames
        : alternateModuleNames
          ? [alternateModuleNames]
          : [];
      const allowed = [...primary, ...alternates].filter(Boolean);
      const checkmodule = allowed.some((name) =>
        permissionModules.includes(name),
      );
      return Promise.resolve(checkmodule);
    } else {
      this.router.navigate(['login']);
    }
  }

}
